let LOADING = `読み込み中 ...`;
let CLOSE = `閉じる`;

export default { LOADING, CLOSE };
